import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Theme } from 'src/app/core/models/theme.model';
import { ThemeService } from 'src/app/core/service/theme.service';
import { IGeneralText } from 'src/app/core/interfaces/generalText.interface';
import * as LocaleActions from 'src/app/root-store/locale/locale.actions';
import { SessionService } from 'src/app/core/service/session.service';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';

import { select, Store } from '@ngrx/store';
import * as ConfigActions from 'src/app/root-store/config/actions/config.actions';
import * as fromLocale from 'src/app/root-store/locale/locale.selectors';
import { TextService } from 'src/app/core/service/text.service';

import { getStatus } from 'src/app/root-store/status/status.selectors';
import { StatusType } from 'src/app/core/enum/status.enum';
import { RESTSERVICE } from 'src/app/core/enum/restService.enum';
import { MessageService } from 'primeng/api';
import { RequestService } from 'src/app/core/service/request.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  userMenu: any[];
  @Output() menuButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() toggleHeaderClick: EventEmitter<any> = new EventEmitter();
  @ViewChild('topbarMenu') topbarMenu: ElementRef;
  config: Theme;
  selectedLocale: any;
  subscription: Subscription;
  userId: string;
  locale: string;
  hidedenHeader: boolean;
  leftToggleBtn: boolean;
  locales: any[];
  pendingActivity = 0;
  generalTexts: IGeneralText = {
    searchHelpText: { labelId: 'PH_SEARCH' },
    notificationHelpText: { labelId: 'PH_NOTIFICATION' },
    helpHelpText: { labelId: 'PH_HELP' },
    profile: { labelId: 'L_PROFILE' },
    success: { labelId: 'L_REC_ADDED' },
    updated: { labelId: 'L_REC_UPDATED' },
    failed: { labelId: 'L_OPERATION_FAILED' },
    deleted: { labelId: 'L_RECORD_DELETED' },
    uploaded: { labelId: 'L_SUCCESS_UPLOADED' },
    fileDeleted: { labelId: 'L_FILE_DELETED' },
    mgsSuccess: { labelId: 'L_SUCCESSFUL' },
  };

  constructor(
    private configService: ThemeService,
    private sessionService: SessionService,
    public translate: TranslateService,
    private keycloakService: KeycloakService,
    private store: Store,
    private textService: TextService,
    private messageService: MessageService,
    private restApiService: RequestService
  ) {}

  ngOnInit(): void {
    this.store.select(getStatus).subscribe((resp) => {
      if (resp.isUpdated == false) {
        return;
      }
      let messageObj = {
        severity: RESTSERVICE.SUCCESS,
        summary: this.generalTexts.mgsSuccess.label,
        detail: '',
        life: 5000,
        key: 'common-toast',
      };
      switch (resp.type) {
        case StatusType.Created:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.success.label,
          };
          break;
        case StatusType.Updated:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.updated.label,
          };
          break;
        case StatusType.Deleted:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.deleted.label,
          };
          break;
        case StatusType.Uploaded:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.uploaded.label,
          };
          break;
        case StatusType.fileDeleted:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.fileDeleted.label,
          };
          break;
        case StatusType.TryAgain:
          messageObj = {
            ...messageObj,
            detail: 'Try Again',
            severity: RESTSERVICE.ERROR,
            summary: RESTSERVICE.ERRORTITLE,
          };
          break;
        default:
          messageObj = {
            ...messageObj,
            detail: this.generalTexts.failed.label,
            severity: RESTSERVICE.ERROR,
            summary: RESTSERVICE.ERRORTITLE,
          };
          break;
      }
      this.messageService.add(messageObj);
    });

    this.store.pipe(select(fromLocale.getLocales)).subscribe((locales) => {
      if (locales) {
        this.locales = Object.values(locales);
      }
    });

    this.locale = this.sessionService.getItem('ng-app-language');
    this.config = this.configService.config;

    this.subscription = this.configService.configUpdate$.subscribe((config) => {
      this.config = config;
    });
    this.userMenu = [
      { label: 'Profile', labelId: 'L_PROFILE', routerLink: ['/main/profile'] },
      {
        label: 'Logout',
        labelId: 'L_LOGOUT',
        command: () => this.logoutUser(),
      },
    ];
    this.textService
      .convert({ gts: this.generalTexts, userMenu: this.userMenu })
      .subscribe((converted) => {
        this.generalTexts = converted.gts;
        this.userMenu = converted.userMenu;
      });
    this.hidedenHeader = false;

    this.setOrientationAsLocaleSuggests();

    this.restApiService
      .get('/api/v5/work-flow-activities/workflow-status-with-staff', {
        page: 0,
        size: 1000,
      })
      .subscribe((resp) => {
        this.pendingActivity = resp.body.length;
      });
  }

  setOrientationAsLocaleSuggests() {
    this.store.select(fromLocale.getLocaleLabels).subscribe((locale: any) => {
      this.selectedLocale = locale;

      const isRtl = locale?.isRtl;
      const direction = isRtl ? 'rtl' : 'ltr';
      if (isRtl) {
        console.log('rtl');
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
        document.getElementsByTagName('html')[0].classList.add('ui-rtl');
      } else {
        document.getElementsByTagName('html')[0].removeAttribute('dir');
        document.getElementsByTagName('html')[0].classList.remove('ui-rtl');
      }

      const updatedConfig = { ...this.config, direction };
      this.configService.updateConfig(updatedConfig);
      this.store.dispatch(
        ConfigActions.updateConfig({
          theme: updatedConfig,
        })
      );
    });
  }
  logoutUser(): void {
    localStorage.clear();
    this.keycloakService.logout(location.origin);
  }
  getUserName(): string {
    return this.keycloakService.getUsername();
  }
  onMenuButtonClick(event: Event): void {
    this.menuButtonClick.emit();
    event.preventDefault();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  headerClass() {
    return { 'layout-topbar': true, 'hidden-header': this.hidedenHeader };
  }

  toggleHeader(event: Event): void {
    this.hidedenHeader = !this.hidedenHeader;
    this.toggleHeaderClick.emit(this.hidedenHeader);
    event.preventDefault();
  }
  onLanguageChange($event) {
    this.locale = $event.value;
    this.store.dispatch(
      LocaleActions.updateDefaultLocale({ locale: this.locale['id'] })
    );
    console.log(this.locale);
  }
  getClass() {
    return this.hidedenHeader
      ? { 'pi-angle-down': true }
      : { 'pi-angle-up': true };
  }
}
